(() => {
  const storageKey = 'gml_navigation_v2';
  const stateKey = '__gmlNavigation';
  const currentURL = () => location.pathname + location.search + location.hash;
  const safeURL = value => {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|checkout|checkouts|authentication|customer_authentication)(?:\/|$)/i.test(url.pathname) ? url.pathname + url.search + url.hash : '';
    } catch { return ''; }
  };
  const normalizeURL = value => {
    const path = safeURL(value);
    if (!path) return '';
    const url = new URL(window.GmlLocale?.url(path) || path, location.origin);
    if (/\/collections\/(all-watches-1|availables|certified-watches)\/?$/.test(url.pathname)) {
      url.pathname = url.pathname.replace(/\/collections\/[^/]+\/?$/, '/collections/all');
      url.searchParams.set('view', 'gml-inventory');
    }
    return url.pathname + url.search + url.hash;
  };
  let trail = { entries: [], index: -1 };
  const restore = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && Array.isArray(saved.entries) && Number.isInteger(saved.index)) {
        const activeId = saved.entries[saved.index]?.id;
        const entries = saved.entries.filter(item => item && typeof item.id === 'string' && safeURL(item.url)).slice(-80);
        trail = { entries, index: entries.findIndex(item => item.id === activeId) };
        if (saved.replacing && typeof saved.replacing.id === 'string' && safeURL(saved.replacing.url)) trail.replacing = saved.replacing;
      }
    } catch {}
  };
  restore();
  const nativeReplaceState = history.replaceState.bind(history);
  const nativePushState = history.pushState.bind(history);
  let started = false;
  let pendingHash = null;
  const persist = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(trail)); } catch {} };
  const remember = () => {
    const entry = trail.entries[trail.index];
    if (!trail.replacing && entry && history.state?.[stateKey] === entry.id) entry.url = currentURL();
    persist();
  };
  const previous = () => trail.index > 0 ? trail.entries[trail.index - 1] : null;
  const updateLinks = () => {
    const prior = previous();
    document.querySelectorAll('[data-gml-back]').forEach(link => {
      const fallback = normalizeURL(link.dataset.gmlBackFallback || link.getAttribute('href')) || '/';
      link.href = prior && prior.url !== currentURL() ? normalizeURL(prior.url) || fallback : fallback;
    });
  };
  const markCurrent = () => {
    const entry = trail.entries[trail.index];
    if (entry) nativeReplaceState({...history.state, [stateKey]:entry.id}, '', location.href);
  };
  const appendCurrent = (nativePrevious = '') => {
    trail.entries = trail.entries.slice(0, trail.index + 1);
    trail.entries.push({id:Date.now().toString(36) + Math.random().toString(36).slice(2, 9),url:currentURL(),nativePrevious});
    trail.entries = trail.entries.slice(-80);
    trail.index = trail.entries.length - 1;
    markCurrent();
  };
  const afterRoute = () => {
    persist();
    updateLinks();
    // Explorer hash handlers also change the fallback; let their render finish first.
    queueMicrotask(updateLinks);
  };
  const sync = (reason = 'traverse') => {
    if (trail.replacing) {
      const replacing = trail.replacing;
      delete trail.replacing;
      const replacedIndex = trail.entries.findIndex(item => item.id === replacing.id);
      if (replacedIndex >= 0 && replacing.url === currentURL()) {
        trail.index = replacedIndex;
        trail.entries[replacedIndex].url = currentURL();
        markCurrent();
        afterRoute();
        return;
      }
    }
    const id = history.state?.[stateKey];
    if (pendingHash) {
      const pending = pendingHash;
      pendingHash = null;
      const sourceIndex = trail.entries.findIndex(item => item.id === pending.from);
      if (sourceIndex >= 0 && pending.url === currentURL()) {
        trail.index = sourceIndex;
        appendCurrent(pending.from);
        afterRoute();
        return;
      }
    }
    const existing = trail.entries.findIndex(item => item.id === id);
    if (existing >= 0 && (trail.entries[existing].url === currentURL() || reason === 'pageshow')) {
      trail.index = existing;
      trail.entries[existing].url = currentURL();
    } else if (existing >= 0) {
      // A new native hash entry inherits its predecessor's state until we tag it.
      trail.index = existing;
      appendCurrent(trail.entries[existing].id);
    } else {
      const referred = safeURL(document.referrer);
      const prior = trail.entries[trail.index];
      // A saved storefront visit is not proof that it immediately preceded an
      // external/direct arrival. Referrers omit fragments, so compare without one.
      const followsPrior = referred && prior && prior.url.split('#')[0] === referred.split('#')[0];
      if (!followsPrior) {
        trail = {entries:[],index:-1};
      }
      appendCurrent(followsPrior ? prior.id : '');
    }
    afterRoute();
  };
  history.replaceState = function(state, unused, url) {
    const entry = trail.entries[trail.index];
    nativeReplaceState(started && entry ? {...state, [stateKey]:entry.id} : state, unused, url);
    if (started && entry) { entry.url = currentURL(); afterRoute(); }
  };
  history.pushState = function(state, unused, url) {
    const prior = trail.entries[trail.index];
    remember();
    nativePushState(state, unused, url);
    if (started) { appendCurrent(prior?.id || ''); afterRoute(); }
  };
  const tidyLinks = root => root.querySelectorAll('a[href]').forEach(link => {
    if (link.hasAttribute('data-gml-back')) return;
    const original = link.getAttribute('href');
    if (!original || !/\/collections\/(all-watches-1|availables|certified-watches)(?:[/?#]|$)/.test(original)) return;
    const corrected = normalizeURL(original);
    if (corrected) link.href = corrected;
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    remember();
    if (!link.hasAttribute('data-gml-back')) {
      const destination = safeURL(link.href);
      const current = trail.entries[trail.index];
      if (current && destination && destination !== currentURL() && destination.split('#')[0] === currentURL().split('#')[0]) {
        pendingHash = {from:current.id,url:destination};
      }
    }
    if (link.hasAttribute('data-gml-back')) {
      updateLinks();
      const prior = previous();
      const current = trail.entries[trail.index];
      if (prior && current?.nativePrevious === prior.id && prior.url !== currentURL() && normalizeURL(prior.url) === prior.url && history.length > 1) {
        event.preventDefault();
        if (window.GmlPageTransitions) window.GmlPageTransitions.navigate(prior.url, {commit: () => history.back()});
        else history.back();
      } else {
        // A direct visit has no proven storefront predecessor. Replace it with
        // its safe parent so pressing Back again cannot loop to the child.
        const destination = normalizeURL(link.href) || '/';
        event.preventDefault();
        if (destination === currentURL()) return;
        if (current) {
          current.url = destination;
          trail.replacing = {id:current.id,url:destination};
          persist();
        }
        if (window.GmlPageTransitions) window.GmlPageTransitions.navigate(destination, {commit: () => location.replace(destination)});
        else location.replace(destination);
      }
    }
  }, true);
  window.addEventListener('popstate', () => sync());
  window.addEventListener('hashchange', () => sync());
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', () => { if (started) { restore(); sync('pageshow'); } });
  document.addEventListener('shopify:section:load', event => { tidyLinks(event.target); updateLinks(); });
  document.addEventListener('gml:navigation-update', () => { remember(); updateLinks(); });
  const start = () => { started = true; sync('pageshow'); tidyLinks(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

